import {
  ChangeEvent,
  FocusEvent,
  ReactElement,
  ReactNode,
  useState
} from 'react';
import Image from 'next/image';
import cn from 'classnames';

import Text from '@/components/common/Text/Text';
import { useGentleBlurField } from '@/components/form/lib/useGentleBlurField';

import ViewIcon from 'public/img/icon/view-black-yes.svg';
import HideIcon from 'public/img/icon/view-black-no.svg';

import '../InputField/InputField.style.scss';
import './PasswordField.style.scss';

type PasswordFieldProps = {
  className?: string;
  name: string;
  label: ReactNode;
  /** Optional HTML autocomplete token (e.g. "new-password"). */
  autoComplete?: string;
  'data-testid'?: string;
};

function PasswordField(props: PasswordFieldProps): ReactElement {
  const {
    className = '',
    name,
    label,
    autoComplete,
    'data-testid': dataTestId
  } = props;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [field, meta] = useGentleBlurField({ name });

  const handleVisibilityClick = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={cn('InputField', 'PasswordField', className)}>
      <label className='InputField-label PasswordField-label'>{label}</label>
      <div className='PasswordField-input-container'>
        <input
          {...field}
          type={showPassword ? 'text' : 'password'}
          className='InputField-input PasswordField-input'
          autoComplete={autoComplete}
          data-testid={dataTestId}
        />
        <Image
          className='PasswordField-vis-icon cursor'
          height={32}
          width={32}
          alt='Toggle Password visibility'
          src={showPassword ? HideIcon : ViewIcon}
          onClick={handleVisibilityClick}
        />
      </div>
      {meta.touched && meta.error && (
        <div className='InputField-error PasswordField-error'>
          <Text className='InputField-error-text PasswordField-error-text'>
            {meta.error}
          </Text>
        </div>
      )}
    </div>
  );
}

export default PasswordField;
